export default {
  nav: {
    dashboard: 'Dashboard',
    campaigns: 'Campaigns',
    landingPages: 'Landing Pages',
    offers: 'Offers',
    conversions: 'Conversions',
    reports: 'Reports',
    alerts: 'Alerts',
    billing: 'Billing',
    trafficSources: 'Traffic Sources',
    clicks: 'Click Log',
    testing: 'Track Testing',
    postbackLogs: 'Postback Logs',
    adminBilling: 'Custom Plans',
    adminPanel: 'Admin',
    backToApp: 'Back to App',
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    confirm: 'Confirm',
    loading: 'Loading...',
    noData: 'No data',
    search: 'Search',
    refresh: 'Refresh',
    back: 'Back',
    next: 'Next',
    prev: 'Previous',
    submit: 'Submit',
    close: 'Close',
    enable: 'Enable',
    disable: 'Disable',
    status: 'Status',
    name: 'Name',
    actions: 'Actions',
    all: 'All',
    yes: 'Yes',
    no: 'No',
    logout: 'Logout',
    prevPage: 'Previous',
    nextPage: 'Next',
    saving: 'Saving...',
    unknown: 'Unknown',
  },
  campaign: {
    title: 'Campaigns',
    create: 'Create Campaign',
    name: 'Campaign Name',
    status: {
      active: 'Active',
      paused: 'Paused',
      archived: 'Archived',
      deleted: 'Deleted',
    },
    costModel: {
      label: 'Cost Model',
      cpc: 'CPC (Cost per Click)',
      cpm: 'CPM (Cost per Mille)',
      cpa: 'CPA (Cost per Action)',
      none: 'None',
    },
    trafficSource: 'Traffic Source',
    offer: 'Offer',
    clicks: 'Clicks',
    conversions: 'Conversions',
    revenue: 'Revenue',
    cost: 'Cost',
    profit: 'Profit',
    cvr: 'CVR',
    epc: 'EPC',
    roi: 'ROI',
    action: {
      pause: 'Pause',
      start: 'Start',
      clone: 'Clone',
      archive: 'Archive',
    },
    wizard: {
      step1: 'Basic Info', step2: 'Target', step3: 'Cost', step4: 'Advanced', step5: 'Confirm',
      trafficSource: 'Traffic Source',
      fallbackUrl: 'Fallback URL (optional)',
      costModel: 'Cost Model', costValue: 'Cost Value', currency: 'Currency',
      tags: 'Tags', tagsHint: 'Separate tags with commas', tagsPlaceholder: 'tag1, tag2, tag3',
      notes: 'Notes', notesPlaceholder: 'Add notes...',
      selectOffer: 'Select an Offer...',
      noOffers: 'No offers available. Create one in {link} first.',
      confirmMsg: 'Review the settings below before creating the Campaign',
      nameLabel: 'Campaign Name', namePlaceholder: 'Enter campaign name',
      saveDraft: 'Save Draft', createBtn: 'Create Campaign',
      errName: 'Campaign name is required', errTrafficSource: 'Please select a traffic source',
      errOffer: 'Please select an offer', errUrl: 'Please enter a valid URL', errCostValue: 'Please enter a valid cost value',
      step1Desc: 'Set campaign name and select traffic source',
      step2Desc: 'Select the Offer for this campaign',
      step3Desc: 'Set campaign cost model and value',
      step4Desc: 'Add tags and notes for management',
      step5Desc: 'Preview',
      currencyUSD: 'USD (Dollar)', currencyCNY: 'CNY (Yuan)', currencyEUR: 'EUR (Euro)', currencyGBP: 'GBP (Pound)',
      subtitle: 'Configure your ad tracking campaign step by step',
      trafficSourceParams: 'Traffic Source Parameters',
      trafficSourceParamsHint: 'Configure {name} tracking parameters, they will be added to the tracking link',
      trafficSourceParamsLabel: 'Traffic Source Params',
      fallbackHint: 'Redirect here when the target URL is unavailable',
      trackingDomain: 'Custom Tracking Domain',
      trackingDomainHint: 'Leave empty to use the default tracking domain',
      noTags: 'No tags available',
      newTagPlaceholder: 'New tag name',
      folderPlaceholder: 'e.g. 2024 Campaigns',
      notSelected: 'Not selected',
      createTagFailed: 'Failed to create tag',
      createFailed: 'Failed to create, please try again',
      confirmTitle: 'Confirm Configuration',
      confirmHint: 'After creation, tracking link and Postback URL will be generated automatically.',
      errNameMin: 'Name must be at least 2 characters',
      errNameMax: 'Name must be at most 100 characters',
      errCostRequired: 'Please enter a cost value',
      errCostNegative: 'Cost value cannot be negative',
      editTitle: 'Edit Campaign',
      editSubtitle: 'Modify campaign configuration',
      destinationUrl: 'Destination URL',
      saveFailed: 'Failed to save, please try again',
      selectTrafficSource: 'Select traffic source',
    },
    detail: {
      trackingLink: 'Tracking Link', postbackHint: 'Configure this URL in your traffic source to receive conversion data',
      todayData: "Today's Stats", clicks: 'Clicks', conversions: 'Conversions', revenue: 'Revenue', cost: 'Cost',
      trend: 'Trend', revenueCost: 'Revenue & Cost',
      conversionList: 'Conversions', total: '{n} total', addManual: '+ Add Manually',
      noConversions: 'No conversions yet',
      config: 'Configuration', trafficSource: 'Traffic Source', costModel: 'Cost Model',
      trackingDomain: 'Tracking Domain', defaultDomain: 'Default Domain', folder: 'Folder', tags: 'Tags',
      noTrafficSource: 'No traffic source', createdAt: 'Created', statusControl: 'Status',
      copied: 'Copied', copy: 'Copy',
      quickActions: 'Quick Actions', editConfig: 'Edit Config', editConfigDesc: 'Modify campaign settings',
      viewReports: 'View Reports', viewReportsDesc: 'Detailed analytics',
      qrCode: 'QR Code', qrCodeDesc: 'Tracking link QR code',
      roiAnalysis: 'ROI Analysis', returnRate: 'Return on Investment',
      notFound: 'Campaign not found or deleted', backToList: 'Back to List',
      addConversionTitle: 'Add Conversion', adding: 'Adding...', confirmAdd: 'Confirm',
      convStatus: 'Status', approve: 'Approve', reject: 'Reject', none: 'None',
    },
    archiveConfirmTitle: 'Confirm Archive',
    archiveConfirmMsg: 'Are you sure you want to archive this Campaign?',
    archiveConfirmBtn: 'Archive',
  },
  conversion: {
    title: 'Conversions',
    status: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
    },
    payout: 'Payout',
    goal: 'Goal',
    addManual: 'Add Conversion',
    totalCount: '{n} total',
    allCampaigns: 'All Campaigns',
    noData: 'No conversions yet',
    approve: 'Approve',
    reject: 'Reject',
    pagination: '{from}-{to} of {total}',
  },
  report: {
    title: 'Reports',
    today: 'Today',
    days7: '7 Days',
    days30: '30 Days',
    totalClicks: 'Total Clicks',
    uniqueClicks: 'Unique Clicks',
    totalConversions: 'Conversions',
    totalRevenue: 'Revenue',
    totalProfit: 'Profit',
    avgCvr: 'Avg CVR',
    avgEpc: 'Avg EPC',
    custom: 'Custom',
    trendChart: 'Clicks & Conversions Trend',
    revenueCost: 'Revenue & Cost',
    campaignDetail: 'Campaign Breakdown',
    trafficDetail: 'Traffic Source Breakdown',
    languageDetail: 'Language',
    carrierDetail: 'Carrier',
    connectionDetail: 'Connection',
  },
  alert: {
    title: 'Alerts & Notifications',
    rules: 'Alert Rules',
    notifications: 'Notifications',
    createRule: 'New Rule',
    checkNow: 'Check Now',
    checking: 'Checking...',
    noRules: 'No alert rules yet',
    noNotifications: 'No notifications',
    markAllRead: 'Mark all as read',
    metric: {
      clicks: 'Clicks',
      conversions: 'Conversions',
      cvr: 'CVR (%)',
      revenue: 'Revenue ($)',
      profit: 'Profit ($)',
      epc: 'EPC ($)',
    },
    condition: { lt: 'below', gt: 'above' },
    threshold: 'Threshold',
    windowHours: 'Time Window (hours)',
    allCampaigns: 'All Campaigns',
    editRule: 'Edit Rule',
    newRule: 'New Alert Rule',
    ruleName: 'Rule Name',
    ruleNamePlaceholder: 'e.g. Low CVR Alert',
    metricLabel: 'Metric',
    conditionLabel: 'Condition',
    campaignFilter: 'Campaign (empty = all)',
    recentCount: 'Recent 100',
    pastHours: 'Past {h}h',
    currentValue: 'Current Value',
    fired: '{n} alert(s) triggered',
    noFired: 'Check complete, no alerts triggered',
    notifyEmail: 'Notify Email',
  },
  billing: {
    title: 'Usage & Billing',
    currentPeriod: 'This Month',
    free: 'Free',
    billableUsage: 'Billable Usage',
    estimatedBill: 'Estimated Bill',
    pricingNote: 'Pricing',
    freeQuotaDesc: 'First {n} clicks per month free',
    overageDesc: 'Then ${price} per 1,000 clicks',
    customBadge: 'Custom Plan',
    allFeatures: 'All features included, no limits',
    invoiceHistory: 'Invoice History',
    invoiceMonth: 'Month',
    invoiceClicks: 'Clicks',
    invoiceBilled: 'Billed Clicks',
    invoiceAmount: 'Amount',
    invoiceStatus: 'Status',
    noInvoices: 'No invoices yet',
    enterprise: 'Running 10M+ clicks/month?',
    enterpriseCta: 'Contact us for a custom quote',
    usage: {
      clicks: 'Clicks',
    },
    status: {
      draft: 'Draft',
      issued: 'Issued',
      paid: 'Paid',
    },
  },
  adminOrgs: {
    title: 'Organizations',
    orgName: 'Organization',
    memberCount: 'Members',
    campaignCount: 'Campaigns',
    monthClicks: 'Monthly Clicks',
    customPlan: 'Custom Plan',
    createdAt: 'Registered',
    noData: 'No organizations found',
    searchPlaceholder: 'Search by name or ID...',
    detail: 'Details',
    members: 'Members',
    recentCampaigns: 'Recent Campaigns',
    totalCount: '{n} organizations',
    estimatedBill: 'Est. Bill',
  },
  adminBilling: {
    title: 'Custom Plans',
    addConfig: 'Add Custom Plan',
    editConfig: 'Edit Custom Plan',
    orgName: 'Organization',
    freeClicks: 'Free Quota (clicks/month)',
    pricePerK: 'Overage Price (per 1k)',
    note: 'Note',
    notePlaceholder: 'e.g. VIP client, enterprise deal',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    deleteConfirm: 'Delete this custom plan? The org will revert to default pricing.',
    noConfigs: 'No custom plans yet',
    searchOrg: 'Search by org name or ID',
  },
  offer: {
    title: 'Offers',
    create: 'New Offer',
    payout: 'Payout',
    status: {
      active: 'Active',
      paused: 'Paused',
      archived: 'Archived',
    },
    searchPlaceholder: 'Search by name or URL...',
    noData: 'No offers yet',
    editTitle: 'Edit Offer',
    createTitle: 'New Offer',
    nameLabel: 'Name *',
    namePlaceholder: 'Summer Promo Offer',
    landingPageLabel: 'Landing Page',
    noLandingPage: 'None',
    currencyLabel: 'Currency',
    statusLabel: 'Status',
    notesLabel: 'Notes',
    notesPlaceholder: 'Optional notes...',
  },
  landingPage: {
    title: 'Landing Pages',
    create: 'New Landing Page',
    url: 'URL',
    notes: 'Notes',
    searchPlaceholder: 'Search by name or URL...',
    noData: 'No landing pages yet',
    editTitle: 'Edit Landing Page',
    createTitle: 'New Landing Page',
    nameLabel: 'Name *',
    namePlaceholder: 'Homepage',
    notesLabel: 'Notes',
    notesPlaceholder: 'Optional notes...',
  },
  trafficSource: {
    title: 'Traffic Sources',
    create: 'New Traffic Source',
    type: 'Type',
    subtitle: 'Manage your ad traffic sources and tracking configurations',
    searchPlaceholder: 'Search traffic sources...',
    noData: 'No traffic sources yet',
    noDataHint: 'Click the button above to create your first traffic source',
    preset: 'Preset',
    noDesc: 'No description',
    detailBtn: 'Details',
    clone: 'Clone',
    typeLabel: {
      all: 'All', google: 'Search Ads', meta: 'Social Ads', tiktok: 'TikTok',
      native: 'Native Ads', push: 'Push Ads', custom: 'Custom',
    },
    quickCreate: 'Quick Create Traffic Source',
    quickCreateDesc: 'Create a custom traffic source for tracking a specific ad platform',
    nameLabel: 'Traffic Source Name',
    namePlaceholder: 'e.g. My Ad Platform',
    descLabel: 'Description (optional)',
    descPlaceholder: 'Traffic source description...',
    errName: 'Please enter a traffic source name',
    createFailed: 'Creation failed, please try again',
    creating: 'Creating...',
    createCustom: 'Create Custom Traffic Source',
    paramsPreview: 'Tracking Parameters Preview',
    noMatch: 'No matching traffic sources found',
    editTitle: 'Edit Traffic Source',
    createTitle: 'Create Traffic Source',
    descLabel2: 'Description',
    descPlaceholder2: 'Enter description (optional)',
    trackingParams: 'Tracking Parameters',
    addParam: '+ Add Parameter',
    noParams: 'No tracking parameters. Click above to add.',
    paramName: 'Parameter Name',
    paramDesc: 'Description (optional)',
    required: 'Required',
    postbackConfig: 'Postback Configuration',
    postbackSupported: 'Supports Postback',
    requestMethod: 'Request Method',
    clickIdParam: 'Click ID Param Name',
    payoutParam: 'Payout Param Name',
    saveChanges: 'Save Changes',
    postbackUrlTemplate: 'Postback URL Template',
    notFound: 'Traffic source not found',
    postbackNotSupported: 'This traffic source does not support Postback',
    statusParam: 'Status Param Name',
    detail: {
      campaignCount: 'Campaigns',
      todayRoi: "Today's ROI",
    },
  },
  notFound: {
    title: 'Page Not Found',
    desc: 'The page you are looking for does not exist.',
    back: 'Back to Home',
  },
  login: {
    subtitle: 'Sign in to your account to continue',
    signIn: 'Sign In',
  },
  home: {
    freeTrial: 'Free Trial',
    nav: { features: 'Features', pricing: 'Pricing', faq: 'FAQ' },
    hero: {
      title: "Track Every Click. Pay Only for What You Use.",
      desc: "Tracking links, Postback conversions, real-time reports — everything media buyers need. First 10,000 clicks/month free forever, then $0.05 per 1,000 clicks. No subscription, no hidden fees.",
      start: 'Get Started Free',
      demo: 'View Demo',
      noCreditCard: 'No credit card required · Cancel anytime',
    },
    stats: { responseTime: 'Avg Response Time', uptime: 'Uptime', platforms: 'Ad Platforms', costSaving: 'per 1,000 clicks' },
    features: {
      title: 'Core Features', subtitle: "Everything media buyers actually need — nothing they don't",
      speed: { title: 'Never Miss a Click', desc: '50ms edge response via Cloudflare global network — your tracking links never time out' },
      reports: { title: 'Real-time Visibility', desc: 'Clicks recorded instantly. ROI, CVR, and EPC visible the moment they happen' },
      multiPlatform: { title: '10+ Platforms, Zero Setup', desc: 'Google, Meta, TikTok and more — pre-configured and ready to go' },
      cost: { title: 'Pay as You Go, No Minimum', desc: 'First 10,000 clicks/month free forever. Then $0.05 per 1,000 clicks — no subscription, no surprises' },
      security: { title: 'Secure & Always On', desc: 'Enterprise-grade encryption, 99.9% uptime. Your data stays yours' },
      easyUse: { title: 'Live in 5 Minutes', desc: 'No training needed. Create a campaign, generate a tracking link, go live — same day' },
    },
    pricing: {
      title: 'Pay as You Go, Start for Free',
      subtitle: 'No subscription, no minimum spend — pay only for what you use',
      freeClicks: '10,000',
      freeDesc: 'clicks / month, free forever',
      overageLabel: 'Then only',
      overagePrice: '$0.05',
      overageUnit: 'per 1,000 clicks',
      featuresTitle: 'All features included, no limits',
      f1: 'Unlimited Campaigns', f2: 'Postback conversion tracking', f3: 'Traffic distribution rules',
      f4: 'Real-time multi-dimensional reports', f5: 'Fraud click filtering', f6: 'API access',
      examplesTitle: 'Cost examples',
      ex1l: '10,000 / month', ex1p: 'Free',
      ex2l: '100,000 / month', ex2p: '$4.50',
      ex3l: '500,000 / month', ex3p: '$24.50',
      ex4l: '1,000,000 / month', ex4p: '$49.50',
      cta: 'Get Started Free',
      noCreditCard: 'No credit card required · Cancel anytime',
      enterpriseTitle: 'Running 10M+ clicks/month?',
      enterpriseCta: 'Contact us for a custom quote',
    },
    faq: {
      title: 'FAQ',
      q1: 'How is LiteTrack different from Voluum?', a1: "Voluum starts at $149/mo with a steep learning curve. LiteTrack is pay-as-you-go — first 10,000 clicks/month free forever, then $0.05 per 1,000 clicks, no subscription, no minimum spend. It covers 90% of what media buyers actually need: tracking links, Postback, multi-dimensional reports, and traffic distribution. If you don't need DSP integrations or white-labeling, LiteTrack is the smarter choice.",
      q2: 'Where is data stored?', a2: 'Data is stored on the Cloudflare global edge network, ensuring low latency and high availability. All data is encrypted.',
      q3: 'Which ad platforms are supported?', a3: 'Currently supports Google Ads, Meta Ads, TikTok Ads, Microsoft Ads, Taboola, Outbrain, MGID, PropellerAds, Zeropark, and custom traffic sources.',
      q4: 'How is billing calculated?', a4: 'Billed by actual click volume. First 10,000 clicks/month are free forever. Beyond that, $0.05 per 1,000 clicks. No subscription, no minimum spend, no credit card required.',
    },
    cta: { title: 'Launch your first tracking campaign today', desc: 'Sign up free, configure in 5 minutes. No credit card, cancel anytime.', btn: 'Get Started Free' },
    footer: { tagline: 'The lean tracking tool for media buyers', privacy: 'Privacy Policy', terms: 'Terms of Service', contact: 'Contact Us' },
  },
  dashboard: {
    activeCampaigns: 'Active Campaigns',
    todayClicks: "Today's Clicks",
    todayConversions: "Today's Conversions",
    cvr: 'CVR',
    welcome: 'Welcome back, {name}',
    user: 'User',
    overview: 'Here is an overview of your campaigns today.',
    recentCampaigns: 'Recent Campaigns',
    draft: 'Draft',
    createCampaign: 'Create Campaign',
    createCampaignDesc: 'Set up a new tracking campaign',
    viewReportsDesc: 'View detailed analytics',
  },
  campaigns: {
    subtitle: 'Manage and monitor all your campaigns',
    filter: 'Filter',
    searchPlaceholder: 'Search campaigns...',
    filterTitle: 'Filter Options',
    clearAll: 'Clear All',
    noFolders: 'No folders',
    noTags: 'No tags',
    selected: '{n} selected',
    batchStart: 'Start',
    batchPause: 'Pause',
    batchArchive: 'Archive',
    batchDelete: 'Delete',
    noData: 'No campaigns found',
    noDataHint: 'Create your first campaign to get started',
    todayClicks: "Today's Clicks",
    todayConversions: "Today's Conversions",
    todayRevenue: "Today's Revenue",
    todayCost: "Today's Cost",
    createdAt: 'Created At',
    totalRecords: '{n} records total',
    perPage: '{n} / page',
  },
  clicks: {
    title: 'Click Log',
    searchPlaceholder: 'Click ID or IP...',
    allCampaigns: 'All Campaigns',
    zoneIdPlaceholder: 'Zone ID...',
    bannerIdPlaceholder: 'Banner ID...',
    carrierPlaceholder: 'Carrier...',
    regionPlaceholder: 'Region...',
    perPage: '{n} / page',
    columns: 'Columns',
    noData: 'No clicks found',
    pagination: '{total} records, page {page} / {pages}',
    detail: {
      title: 'Click Detail',
      subParams: 'Sub Params',
      referrer: 'Referrer',
      userAgent: 'User Agent',
      queryParams: 'Query Params',
      extraParams: 'Extra Params',
    },
    col: {
      time: 'Time', clickId: 'Click ID', campaign: 'Campaign', ip: 'IP',
      location: 'Country/City', device: 'Device', os: 'OS', browser: 'Browser',
      sub1: 'Sub1', unique: 'Unique', fraud: 'Fraud',
      city: 'City', region: 'Region', timezone: 'Timezone', isp: 'ISP',
      brand: 'Brand', osVersion: 'OS Version', browserVer: 'Browser Ver',
      carrier: 'Carrier', connection: 'Connection', userActivity: 'User Activity',
      zoneId: 'Zone ID', bannerId: 'Banner ID', cost: 'Cost',
    },
  },
  apiTokens: {
    title: 'API Tokens',
    tokenCreated: "Token created — copy it now, it won't be shown again:",
    dismiss: 'Dismiss',
    namePlaceholder: 'Token name',
    noTokens: 'No API tokens',
    created: 'Created {time}',
    lastUsed: 'Last used {time}',
    never: 'Never',
    revoke: 'Revoke',
  },
  testing: {
    title: 'Track Testing',
    configTitle: 'Test Configuration',
    payoutLabel: 'Payout ($)',
    sub1Label: 'sub1',
    sub1Optional: '(optional)',
    running: 'Running...',
    runTest: 'Run Full Test',
    resultTitle: 'Test Results',
    allPass: 'All Passed',
    hasFail: 'Has Failures',
    step: {
      sendClick: 'Send Test Click',
      sendPostback: 'Send Test Postback',
      verifyClick: 'Verify Click in DB',
      verifyConversion: 'Verify Conversion in DB',
    },
    detail: {
      skipNoClickId: 'Skipped: no clickId from previous step',
      foundClickId: 'Found clickId: {id}',
      notFoundClickId: 'clickId not found: {id} ({n} records returned)',
    },
  },
  distribution: {
    title: 'Distribution Rules',
    createRule: 'New Rule',
    noRules: 'No rules — clicks go directly to the campaign offer URL',
    defaultRule: 'Default Fallback',
    conditions: 'Conditions (all must match)',
    targets: 'Targets (weighted random)',
    addCondition: '+ Add Condition',
    addTarget: '+ Add Target',
    priority: 'Priority (lower = higher priority)',
    isDefault: 'Set as default fallback rule (matches all traffic)',
    weight: 'Weight',
    dailyClickCap: 'Daily Click Cap',
    customUrl: 'Custom URL',
    noLimit: 'No limit',
    editRule: 'Edit Rule',
    newRule: 'New Distribution Rule',
    ruleName: 'Rule Name',
    optional: 'Optional',
    directToOffer: 'Direct to Offer',
    lpThenOffer: 'Visit landing page first, then redirect to offer',
    noConditions: 'No conditions = match all traffic',
    paramName: 'Param name',
    value: 'Value',
    targetUrl: 'Target URL',
    saving: 'Saving...',
    ruleNum: 'Rule #{n}',
    conditionLabel: 'Conditions',
    targetLabel: 'Targets',
    weightLabel: 'weight {n}',
    field: {
      country: 'Country',
      device_type: 'Device Type',
      os: 'OS',
      browser: 'Browser',
      language: 'Language',
      referrer: 'Referrer',
      param: 'URL Param',
    },
    op: {
      eq: 'equals',
      neq: 'not equals',
      contains: 'contains',
      in: 'in (comma-separated)',
    },
  },
  postbackLog: {
    title: 'Postback Logs',
    noData: 'No postback logs found',
    totalCount: '{n} total',
    allCampaigns: 'All Campaigns',
    allStatus: 'All Status',
    success: 'Success',
    failed: 'Failed',
    pagination: '{total} records, {from}–{to}',
    col: {
      time: 'Time',
      campaign: 'Campaign',
      clickId: 'Click ID',
      url: 'URL',
      method: 'Method',
      httpStatus: 'HTTP',
      duration: 'Duration',
      error: 'Error',
    },
  },
}
